import { useState } from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {AsideDefault} from '../../../_metronic/layout/components/aside/AsideDefault'
import {HeaderWrapperFluid} from '../../../_metronic/layout/components/header/HeaderWrapperFluid'
import {PageTitle} from '../../../_metronic/layout/core'
import { GetAcessoUsuarioProduto } from '../../utils/PermissoesAcesso'
import { MutationSetLogAcessoRecurso } from '../../graphql/services/LogAcesso'

export function RelatorioMCMV() {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 990)
  const permissao = GetAcessoUsuarioProduto(72)
  const {FormSetLogAcessoRecurso} = MutationSetLogAcessoRecurso()
    FormSetLogAcessoRecurso({
      ferramenta: 'inteligencia-mercado',
      funcionalidade: 'relatorio-mcmv',
      action: 'list',
      url: '/relatorio-mcmv',
    })
  return (
    <>
    
     <PageTitle breadcrumbs={[]}>Edição especial - Minha casa, Minha vida</PageTitle>
      <AsideDefault />
      <HeaderWrapperFluid title='Edição especial - Minha casa, Minha vida' />
      <div
        className='wrapper d-flex flex-column flex-row-fluid'
        id='kt_wrapper'
        style={{minWidth: 0}}
      >
         {!permissao ? (
              <div className='content  d-flex flex-column flex-column-fluid' id='kt_content'>
                <div className='card-form px-4 py-12 mb-6' style={{height: '74vh'}}>
                  <div id='kt_content_container' className='container-fluid'>
                    <div className='alert alert-warning'>
                      <h3 className='pt-2 ps-2'>
                        Você não tem este produto contratado, por favor entre em contato no email:{' '}
                        <a href='mailto:contato@urbit.com.br?subject=Sobre Avaliação de Imóveis&body=Gostaria de informações sobre o produto de avaliação de imóveis.'>
                          contato@urbit.com.br
                        </a>
                      </h3>
                      {/* <MensagemAlertAcesso mensagem='Somente para assinantes do Produto - Urbit Pricing.'></MensagemAlertAcesso> */}
                    </div>
                    <div className='d-flex justify-content-center align-content-center'>
                     {isMobile ?  (
                        <img src={toAbsoluteUrl('/media/bloqueio-desktop 1440@1x.png')} alt='print-im ' width='100%' />
                      ) : (
                        <img src={toAbsoluteUrl('/media/bloqueio-mobile 390@1x.png')} alt='print-im ' width='100%' />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

     {permissao ? (<>
        <div id='kt_content' className='content d-flex flex-column flex-column-fluid p-0'>
          <iframe
            title='Relatório de mercado Minha Casa, Minha Vida'
            src={toAbsoluteUrl('/relatorios/mcmv/202609_relatorio_MCMV_Urbit_completo.html')}
            style={{
              display: 'block',
              width: '100%',
              height: 'calc(100vh - 80px)',
              minHeight: 480,
              border: 0,
              flex: 1,
              paddingTop: 2,
            }}
          />
        </div>
      :</>) : (<></>)}

         </div>
    </>
  )
}
